import { useContext, useState } from 'react'
import axios from 'axios'
import { observer } from 'mobx-react'
import { StoreContext } from '@store/Root.store'
import { Header, Button } from '../../Generic'
import { devLog } from '@methods/devLog'
import { Illustration } from '@/components/Illustration/Illustration'

interface IntroProps {
  nextStep: () => void
  startMobileSessionUrl?: string
}

export const Intro = observer(({ nextStep, startMobileSessionUrl }: IntroProps) => {
  const store = useContext(StoreContext)
  const { switchToMobile: trans } = store.TranslationsState.translationsNew

  const [disabled, setDisabled] = useState(false)

  const startMobileSession = async () => {
    if (!startMobileSessionUrl) return
    setDisabled(true)

    try {
      await axios.post(startMobileSessionUrl, {}, { withCredentials: true })
    } catch (error) {
      devLog(error)
    }

    nextStep()
    setDisabled(false)
  }

  return (
    <>
      <Illustration type="pin-intro" />

      <Header className="m-30-0">{trans.pinIntro?.header}</Header>

      <p className="generic__intro-paragraph">{trans.pinIntro?.description}</p>

      <div className="layout__content-container-bottom-fixed">
        <Button disabled={disabled} onClick={startMobileSession}>
          <span className="generic__button-text">{trans.pinIntro?.continue}</span>
        </Button>
      </div>

      <div className="layout__mobile-spacer-for-content-container-bottom-fixed" />
    </>
  )
})
